<template>
   <div class="record-list-wrapper">
       <div class="flex-box-column record-list-cover">
           <div class="hd">
               <van-nav-bar 
               left-arrow 
               safe-area-inset-top 
               right-text="搜索" 
               @click-right="onSearch" 
               class="search" 
               @click-left="back">
                <template #title>
                        <van-search v-model="keyword" class="sm border" shape="round" placeholder="请输入关键字搜索订单" @search="onSearch" ref="recordListSearch"/>
                    </template>
                </van-nav-bar>
                <div class="menu border_bottom z-index-10">
                    <van-dropdown-menu class="z-index-10" :close-on-click-outside="false" ref="recordListMenu">
                        <van-dropdown-item v-model="flowPathValue" @change="flowPathChange" :options="recordStatusOptions" :title="flowPathTitle" :class="{'base-color':role=='AUDITORADMIN' || role=='AUDITOR'}"/>
                        <van-dropdown-item ref="record_date" :title="recordTimeTitle">
                            <van-cell center :title="item.text" @click="selectDate(item)" v-for="(item,index) in option2" :title-class="{active:recordTimeIndex == index}" :key="index"/>
                            <div class="date-interval">
                                <div class="date-interval-item" @click="calendarOpen">{{recordStartTime ? recordStartTime :'开始时间'}}</div>
                                <div class="g">一</div>
                                <div class="date-interval-item" @click="calendarOpen">{{recordEndTime ? recordEndTime :'结束时间'}}</div>
                                <button 
                                class="confirm date-interval-item" 
                                @click="selectDate({text:'自选时间',value:99})"
                                :class="{live:this.recordStartTime && this.recordEndTime}"
                                >确定</button>
                            </div>
                        </van-dropdown-item>
                        <van-dropdown-item v-model="staffValue" @change="staffChange" :options="getStaffList" :title="staffTitle" v-if="isSubDistributor"/>
                    </van-dropdown-menu>
                </div>
           </div>
           <div class="bd" ref="recordListScrollView">
                <van-pull-refresh v-model="refreshing" @refresh="onRefresh" :disabled="listError && recordList.length == 0">
                    <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :offset="100"
                    :error.sync="listError"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad"
                    >
                        <div class="record-item border_bottom_top" :class="{'m-selected':!!selectedItemObj[item.id]}" v-for="(item,index) in recordList" @click="linkTo(item)" :key="index">
                            <div class="record-item-multiple-overly" v-if="multiple"></div>
                            <div class="record-item-cover">
                                <div class="record-item-l avatar" :class="{man:item.customerInfo.sex == 1,woman:item.customerInfo.sex==2}"></div>
                                <div class="record-item-r">
                                    <div class="info border_bottom">
                                        <div class="customer">
                                            <div class="name">{{item.customerInfo.name}}<span class="phone">{{item.customerInfo.phone}}</span></div>
                                            <!-- 时间判断 是否为报备无效以及退房 -->
                                            <div class="record-time" :class="{close:item.approvalStatus == 'RECORDCLOSE' || item.approvalStatus == 'MAKEBARGAINCLOSE'}">
                                                {{
                                                    item.approvalStatus == 'RECORDSTART'
                                                    
                                                    ? item.createdAt

                                                    : item.approvalStatus == 'RECORDSTANDBY' ? item.auditAt : item.operateAt
                                                }}
                                            </div>
                                        </div>
                                        <div class="house-name">{{item.houseName}}</div>
                                        <div class="visit-date" v-if="item.approvalStatus == 'VISIT'"><div class="color-999">到访时间：{{item.visitTime}}</div></div>
                                        <div class="staff-info" v-if="role == 'CHANNEL' || role == 'CHANNELJINGLI' || isSubDistributor || role=='AUDITORADMIN' || role=='AUDITOR'">
                                            <span>经纪人：{{item.subdistributorUserName}}</span><a class="tel" :href="'tel:'+item.subdistributorUserPhone" v-if="item.subdistributorUserPhone" @click.stop>{{item.subdistributorUserPhone}}<van-icon name="phone" class="call-icon"></van-icon></a>
                                        </div>
                                        <div class="staff-info">
                                            <span>带看人：{{item.dkName || item.subdistributorUserName}}</span>
                                            <a 
                                                class="tel" 
                                                :href="'tel:'+ item.dkPhone ||  item.subdistributorUserPhone"  
                                                @click.stop>{{item.dkPhone || item.subdistributorUserPhone}}<van-icon name="phone" class="call-icon"></van-icon>
                                            </a>
                                        </div>        
                                        <div class="staff-info" v-if="(role=='AUDITORADMIN' || role=='AUDITOR' || role =='YUEWUYUAN' || role == 'DIANZHANG') && item.channelName && item.channelMobile">
                                            <span>渠道对接人：{{item.channelName}}</span>
                                            <a 
                                                class="tel" 
                                                :href="'tel:'+ item.channelMobile"  
                                                @click.stop>{{item.channelMobile}}<van-icon name="phone" class="call-icon"></van-icon>
                                            </a>
                                        </div>     
                                        <div class="label-item" v-if="role=='AUDITORADMIN' || role=='AUDITOR'">
                                            <span>预计到访时间：</span>
                                            <span>{{item.estimatedVisitTime}}</span>
                                        </div>           
                                        <div class="label-item" v-if="item.reception">
                                            <span>指定接待：</span>
                                            <span>{{item.reception}}</span>
                                        </div>
                                        <div class="label-item primary" v-if="item.supVisiTimeStr">
                                            <span>{{item.supVisiTimeStr}}</span>
                                        </div>
                                    </div>
                                    <div class="des">
                                        <div class="record-type" v-if="item.approvalStatus == 'RECORDCOMPLETE' || item.approvalStatus == 'RECORDCLOSE'">
                                            <div class="record-type-status" v-if="item.approvalStatus == 'RECORDCLOSE'">报备<span class="faild">无效</span></div>
                                            <div class="record-type-status u-flex" v-else @click.stop="showTips(item)">
                                                <span>已发开发商</span>
                                                <div class="record-type-status_icon">
                                                    <van-icon name="warning-o" size="5vw"/>
                                                </div>
                                            </div>
                                            <div class="button-cover">
                                                <!-- <button 
                                                class="record-copy border-all" 
                                                ref="copy_btn"
                                                v-if="role !='CHANNEL' && role != 'CHANNELJINGLI'"
                                                @click.stop="onCopy(item)"
                                                >复制报备信息</button> -->
                                                <button 
                                                class="record-again border-all" 
                                                v-if="(role =='YUEWUYUAN' || role == 'DIANZHANG') && item.isRecordAgain && !item.approvalStatusPermission"
                                                @click.stop="recordAgain(item)"
                                                >重新报备</button>
                                                <button
                                                class="record-again border-all"
                                                v-if="item.approvalStatusPermission"
                                                @click.stop="submitRecordData('UNVISIT','未到访',item)"
                                                >未到访</button>
                                                <button
                                                v-if="item.approvalStatusPermission"
                                                class="record-copy border-all"
                                                @click.stop="submitRecordData('VISIT','已到访',item)"
                                                >已到访</button>
                                            </div>
                                        </div>
                                        <div class="record-type" v-else-if="item.approvalStatus == 'RECORDSTART'">
                                            <div class="record-type-status await">待处理</div>
                                            <div class="button-cover">
                                                <!-- <button 
                                                class="record-copy border-all" 
                                                ref="copy_btn"
                                                v-if="role !='CHANNEL' && role != 'CHANNELJINGLI'"
                                                @click.stop="onCopy(item)"
                                                >复制报备信息</button> -->
                                                <button 
                                                class="record-again border-all" 
                                                v-if="(role =='YUEWUYUAN' || role == 'DIANZHANG') && item.isRecordAgain"
                                                @click.stop="recordAgain(item)"
                                                >重新报备</button>
                                            </div>
                                        </div>    
                                        <div class="record-type" v-else-if="item.approvalStatus == 'RECORDSTANDBY'">
                                            <div class="record-type-status await">{{role == 'DIANZHANG' || role=='YUEWUYUAN' ? '处理中' : '处理中'}}</div>
                                            <div class="button-cover">
                                                <!-- <button 
                                                class="record-copy border-all" 
                                                ref="copy_btn"
                                                v-if="role !='CHANNEL' && role != 'CHANNELJINGLI'"
                                                @click.stop="onCopy(item)"
                                                >复制报备信息</button> -->
                                                <button 
                                                class="record-again border-all" 
                                                v-if="(role =='YUEWUYUAN' || role == 'DIANZHANG') && item.isRecordAgain"
                                                @click.stop="recordAgain(item)"
                                                >重新报备</button>
                                            </div>
                                        </div>
                                        <div class="record-type" v-else>
                                            <div class="record-type-status">
                                                <span :class="{success:item.approvalStatus=='VISIT' || item.approvalStatus == 'MAKEBARGAIN' || item.approvalStatus =='MAKEBARGAINCOMPLETE',faild:item.approvalStatus == 'MAKEBARGAINCLOSE',warning:item.approvalStatus=='UNVISIT'}">{{getApprovalStatusText(item.approvalStatus)}}</span>
                                            </div>
                                            <div class="button-cover">
                                                <!-- <button 
                                                class="record-copy border-all" 
                                                ref="copy_btn"
                                                v-if="role !='CHANNEL' && role != 'CHANNELJINGLI'"
                                                @click.stop="onCopy(item)"
                                                >复制报备信息</button> -->
                                                <button 
                                                class="record-again border-all" 
                                                v-if="(role =='YUEWUYUAN' || role == 'DIANZHANG') && item.isRecordAgain"
                                                @click.stop="recordAgain(item)"
                                                >重新报备</button>
                                            </div>
                                        </div>
                                        <div class="record-extra">
                                            <p v-if="item.approvalResult" class="recordFailed">
                                                <span>审核意见：</span>
                                                <span>{{item.approvalResult}}</span>
                                            </p>      
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
           </div>
            <!-- 区间弹窗 -->
            <van-calendar 
            v-model="calendarShow" 
            type="range"
            @confirm="selectDateInterval" 
            color="#00a0e4"
            :min-date="minDate" 
            :max-date="maxDate" />
            <van-popup 
            v-model="showDatePicker" 
            safe-area-inset-bottom
            close-on-popstate 
            position="bottom"
            >
                <van-datetime-picker
                    v-model="currentTime"
                    type="datetime"
                    title="选择到访时间"
                    :min-date="recordMinDate"
                    :max-date="recordMaxDate"
                    @cancel="closeDatePicker"
                    @confirm="selectVisitDate"
                    :formatter="formatter"
                />
            </van-popup>
       </div>
       <div class="multiple-toolbar-wrapper" v-if="role=='AUDITORADMIN' || role=='AUDITOR'">
           <div class="multiple-toolbar-btn van-icon-system-multiple" v-if="!multiple" @click="multipleStart"></div>     
           <div class="multiple-toolbar-btn van-icon van-icon-cross" v-if="multiple" @click="multipleEnd"></div>   
            <div class="multiple-toolbar-btn van-icon van-icon-eye" v-if="multiple" @click="multipleCtnCheck"></div>  
           <div class="multiple-toolbar-btn van-icon van-icon-success" v-if="multiple" @click="multipleSelectComplete"></div>
       </div>
   </div>
</template>

<script>

import api from "@/api";

import { getDateFky,dateChange,pickerFormatter,findIndex,cloneDeep,isObjectNone } from "@/utils";

import back from "@/mixins/back";

import getStatusTextMixin from "@/mixins/getStatusText";

import permissionCheckMixin from "@/mixins/permissionCheck";

import recordListMultiple from "@/mixins/recordListMultiple"

export default {

    mixins:[back,getStatusTextMixin,permissionCheckMixin,recordListMultiple],

    computed:{

        //是否为开发商列表

        isSubDistributor(){

            return this.$route.name == 'subDistributorRecordList';

        },

        getStaffList(){

            return this.staffList || [{text:'不限',value:0}];

        },

        //报备状态列表

        recordStatusList(){

            return this.$store.state.userInfo.recordStatusList || [{text:'不限',value:0}]

        },

        //角色

        role(){

            return this.$store.state.userInfo.distributorStaffType || ''

        },

        
        //公司主体

        companyName(){

            return this.$store.state.userInfo.company?.description || ''

        }
        
    },

    data(){

        return{

            keyword:'',

            recordList:[],

            staffList:[],

            option2: [

                { text: '不限', value: 0 },

                { text: '本日', value: 1 },

                { text: '本周', value: 2 },

                { text: '本月', value: 4 },

                { text: '近3个月', value: 6 },

                { text: '近6个月', value: 7 },

            ],

            //是否到底

            finished:false,

            //是否加载

            loading:false,

            //是否下拉

            refreshing:false,

            //是否出错

            listError:false,

            //页码

            page:1,

            //一页请求的数据

            size:8,

            //日历展示

            calendarShow:false,


            //流程

            flowPathTitle:'流程',

            flowPathValue:0,

            //报备时间

            recordStartTime:'',

            recordEndTime:'',

            recordTimeIndex:0,

            recordTimeTitle:'时间',

            recordTimeObj:{startDate:'',endDate:''},

            //经纪人

            staffTitle:'经纪人',

            staffValue:0,


            //打开时间选择弹窗

            showEndPicker:false,

            showStartPicker:false,

            minDate: new Date(2020, 0, 1),

            maxDate: new Date(),
            
            currentDate: new Date(),
            
            currentDateEnd: new Date(),
            
            

            recordStatusOptions:[],
            visitForm:{},
            showDatePicker:false,
            currentTime:new Date(),
            recordMinDate: new Date(2020, 0, 1),
            recordMaxDate: new Date(2028, 10, 1)
        }

    },


    methods:{
         closeDatePicker(){

            this.showDatePicker=false;

        },

        selectVisitDate(val){
            this.visitForm.visitTime = dateChange(val);
            this.closeDatePicker();
            this.updateRecordData();
        },
        //修改报备单状态
        submitRecordData(type,typeTxt,item){
            this.$dialog.confirm({

                title:`修改订单状态`,

                message:`确定要将订单状态修改为<span style="color:${type=='VISIT' ? '#03bb03' : 'rgb(223, 112, 39)'}"> ${typeTxt} </span>吗？\n此操作不可逆。`,

                confirmButtonColor:`${type=='VISIT' ? '#03bb03' : '#df7027'}`
                

            }).then(()=>{
                
                this.visitForm = {
                    type,
                    item
                }

                //未到访可以直接提交
                if(type == 'UNVISIT'){
                    this.updateRecordData(type,item);
                }else{
                    //先选择到访时间
                    this.showDatePicker = true;
                }
              
            }).catch(()=>{
                
                this.visitForm = {}
            })

        },
        updateRecordData(){

            if(isObjectNone(this.visitForm)) return;

            let formData = {id:this.visitForm.item.id,approvalStatus:this.visitForm.type};

            if(this.visitForm?.visitTime){

                formData.visitTime = this.visitForm.visitTime;

            }

            this.$toast.loading({

                    message:'提交中...',

                    duration:0,

                    overlay:true

            })

            api.submitRecordAuditData({

                    options:formData,

                    success:(res)=>{

                        if(res.type == 200){

                            this.$toast({
                                message:'订单状态修改成功',
                                position:'bottom'
                            });
                            
                            this.$store.commit('setRouterData',{key:"recordListRefresh",value:formData.id});

                            this.recordUpdate(true);

                            this.visitForm={};

                        }else{
                            
                            this.$dialog.alert({

                                title:'提交失败',

                                message:res.msg || "订单数据提交失败，请稍后重试"

                            });
                               
                            this.visitForm={};

                        }

                    },

                    error:(err)=>{
                        this.visitForm={};

                        console.log(err);

                        this.$dialog.alert({

                            title:'提交失败',

                            message:"订单数据提交异常，请稍后重试"

                        })

                    },

                    complete:()=>{

                        this.$toast.clear();

                    }

            })

        },

        //下拉加载

        onRefresh(){

            this.page=1;

            this.finished=true;

            this.getRecordList('refresh');

        },

        //搜索

        onSearch(){

            this.page=1;

            this.$toast.loading({

                message: '正在加载...',
                forbidClick: true,
                duration:0

            })

            this.getRecordList('search');

        },

        //上拉更多

        onLoad(){

            this.getRecordList();

        },

        //获取列表

        getRecordList(type){

            let _options = {

                page:this.page,

                pageSize:this.size,

                keyword:this.keyword,

                approvalStatus:this.flowPathValue,

            }

            if(this.isSubDistributor){

                _options.subdistributorUserId = this.staffValue;

            }

            //添加搜索时间参数

            if(this.recordTimeIndex > 0){

                //只有自选的时候才使用该参数

                if(this.recordTimeIndex == 6 && this.recordStartTime && this.recordEndTime){

                    _options.searchDate = [this.recordStartTime,this.recordEndTime];


                }else{

                    _options.searchDate = [this.recordTimeObj.startDate,this.recordTimeObj.endDate];

                }


            }

            api[this.isSubDistributor ? 'getSubDistributorRecordList' : 'getRecordList']({

                options:_options,

                success:(res)=>{

                    if(res.type == 200){

                        this.listError=false;

                        let last = this.$listLastCheck(res.data.list,this.size);

                        if(!last){

                            this.page++;

                        }

                        this.finished=last;

                        //当第一次加载且为下拉或搜索时,进行数据处理

                        if(this.recordList.length==0 || type =='refresh' || type =='search'){

                            //处理

                            this.recordStatusOptions= res.data.recordType.map((el)=>{

                                return {text:`${(this.role == 'DIANZHANG' || this.role=='YUEWUYUAN') && el.value == 'RECORDSTANDBY' ? '处理中' : el.label}(${el.number || 0})`,value:el.value}

                            });

                        }


                        //首先判断是否存在勾选状态的楼盘

                        if(type == 'refresh' || type == 'search'){

                            this.$refs.recordListScrollView.scrollTop=0;

                            this.recordList = res.data.list;

                            this.$toast.clear();

                            this.refreshing=false;

                        }else{

                            this.recordList.push(...res.data.list);

                        }

                    }else{

                        this.listError = true;

                        if(type == 'refresh' || type == 'search'){

                            this.$toast.fail(res.msg || '订单数据获取失败');

                        }

                    }


                },

                error:(err)=>{

                    console.log(err);

                    this.listError=true;

                    this.$toast.fail('报备列表获取异常');

                },

                complete:(res)=> {

                    if(type == 'refresh'){

                        this.refreshing=false;

                    }

                    if(res?.code && res.code !=200){

                        this.listError = true;
                        
                    }
                    

                    this.loading=false;

                    this.$store.commit('setRouterData',{key:"recordListRefresh",value:0});
                    
                }


            })


        },

        
        //打开日历

        calendarOpen(){

            this.calendarShow=true;

        },

        //选择日历区间

        selectDateInterval(val){

            this.recordStartTime = dateChange(val[0],'date');

            this.recordEndTime = dateChange(val[1],'date');

            this.$nextTick(()=>{

                this.calendarShow = false;

            })

        },


        
        //个别数据更新

        recordUpdate(){

            if(!this.$store.state.routerStore.recordListRefresh || this.recordList.length == 0) return;

            api.getRecordAuditData({

                options:{id:this.$store.state.routerStore.recordListRefresh},

                success:(res)=>{

                    if(res.type == 200){

                        //检查是否存在对应的元素

                        let _index = findIndex(this.recordList,(el)=>{

                            return el.id == res.data.id;

                        });
                        
                        if(_index !=-1){

                            this.$set(this.recordList,_index,res.data);

                            this.$toast({

                                position:'bottom',

                                message:'已更新数据'

                            });

                        }

                    }

                },

                error:(err)=>{

                    console.log(err);

                },

                complete: ()=> {

                    this.$store.commit('setRouterData',{key:"recordListRefresh",value:0});
                    
                }

            })



        },

        //获取经纪人列表

        getStaffSelectList(){

            api.getStaffSelectList({

                success:(res)=>{

                    if(res.type == 200){

                        this.staffList = res.data;

                    }else{

                        this.$toast({

                            message:'获取经纪人列表失败',

                            position:'bottom'

                        })

                    }

                },

                error:(err)=>{

                    console.log(err);

                }

            })

        },
        




        //选择流程下拉菜单

        flowPathChange(data){


            if(data == 0){

                this.flowPathTitle='流程'

            }else{

                this.flowPathTitle=''

            }

            this.$nextTick(()=>{

                this.onSearch();
            })
            

        },

        //选择经纪人下拉菜单

        staffChange(data){

            if(!data){

                this.staffTitle = '经纪人';

            }else{

                //清空将默认使用text

                this.staffTitle = '';

            }

            

            

            this.onSearch();

        },


        //选择时间

        selectDate(date){

            //自选

            if(date.value == 99 && (!this.recordStartTime || !this.recordEndTime)) return;

            if(date.value == 0){

                this.recordTimeTitle='时间'

            }else{

                this.recordTimeTitle=date.text;

            }

            
            this.recordTimeIndex = date.value;

            //获取时间区间

            if(date.value !=99 && date.value!=0){

                //拿到区间，转化为字符串

                let inv = getDateFky(date.value);
                
                this.recordTimeObj.startDate= dateChange(inv.start,'date');

                this.recordTimeObj.endDate = dateChange(inv.end,'date');

                this.recordStartTime = this.recordEndTime = '';


            }else{

                this.recordTimeObj.startDate = this.recordStartTime;

                this.recordTimeObj.endDate = this.recordEndTime;

            }

            this.$refs.record_date.toggle(false);
                
            this.$nextTick(()=>{

                this.onSearch();

            })

            
        },
        
        //打开起始时间区间

        openEndPicker(){

            this.showEndPicker=true;

        },

        //关闭起始时间区间
        
        closeEndPicker(){

            this.showEndPicker=false;

        },

        

        //打开结束时间区间

        openStartPicker(){

            this.showStartPicker=true;

        },

        closeStartPicker(){

            this.showStartPicker=false;

        },

        selectStartDate(val){

            this.recordStartTime = dateChange(val,'date');

            this.closeStartPicker();

        },        
        
        selectEndDate(val){

            this.recordEndTime = dateChange(val,'date');

            this.closeEndPicker();

        },

        //时间区间格式化

        formatter (type, value) {
            
            return pickerFormatter(type,value);

        },







        //点击复制

        onCopy(item){
            let estimatedVisitTime = !!item.estimatedVisitTime ? (item.estimatedVisitTime.split(' '))[0] : '暂无';
            let copyMessage = `一级公司名称：${this.companyName}\n二级公司全称：${item.subdistributorName || '暂无'}\n带看员工：${item.dkName || item.subdistributorUserName}\n员工电话：${item.dkPhone || item.subdistributorUserPhone}\n客户姓名：${item.customerInfo.name}\n客户电话：${item.customerInfo.phone}\n客户性别：${item.customerInfo.sex == 1 ?'男':'女'}\n到访人数：${item.visitorNum}\n带看项目：${item.houseName}\n到访时间：${estimatedVisitTime}\n指定接待：${item.reception || '暂无'}`

            this.$copyText(copyMessage).then(()=>{
                
                this.$toast({

                    message:'报备格式复制成功',

                    position:"bottom"

                });
    
                },()=>{
                
                this.$toast({

                    message:'复制失败，如果多次复制失败，请联系管理员',

                    position:'bottom'

                });

            })

        },


        //重新报备

        recordAgain(item){

            let customerInfo = cloneDeep(item?.customerInfo || null);

            //加上一个时间戳，以便修改用

            customerInfo.time = (new Date()).getTime();

            //设置客户列表

            this.$store.commit('setRecordData',{

                key:"customerList",
                
                value:customerInfo ? [customerInfo] : []

            });

            //设置到访人数

            this.$store.commit('setRecordData',{

                key:"visitorNum",
                
                value:item?.visitorNum || ''

            });

            //设置带看人姓名
            
            this.$store.commit('setRecordData',{

                key:"dkStaffName",
                
                value:item?.dkName || ''

            });

            //设置带看人联系方式
            
            this.$store.commit('setRecordData',{

                key:"dkStaffPhone",
                
                value:item?.dkPhone || ''

            });


            this.$router.push({path:'/house/record/'+item.houseId});

        },



        linkTo(item){
            
            //判断是否为多选模式
            
            if(this.multiple){

                if(this.selectedItemObj[item.id]){

                    this.$delete(this.selectedItemObj,item.id);

                }else{

                    this.$set(this.selectedItemObj,item.id,item);

                }

                

            }else{

                //每次跳转都设置一次跳转内容

                this.$route.meta.scrollTop=this.$refs.recordListScrollView.scrollTop;

                if(this.role == 'AUDITORADMIN' || this.role == 'AUDITOR'){

                    this.$router.push({path:`/record/audit/${item.id}`});
                    
                }else{

                    this.$router.push({path:`/record/detail/${item.id}`});

                }

            }

        },

        showTips(item){
            if(item.approvalStatus != 'RECORDCOMPLETE') return;
            this.$dialog.alert({
                title:'提示',
                message:'报备信息已发开发商，开发商未回复报备结果，报备是否有效以开发商认定结果为准。'
            }).then(()=>{})
        }


    },


    //滚动状态监听

    activated(){
        
        if(this.$route.params.name && this.$route.params.id){
            this.staffTitle = this.$route.params.name;
            this.staffValue = this.$route.params.id;
        }
        this.$nextTick(()=>{

                if(this.recordStatusOptions.length == 0){

                    this.recordStatusOptions = this.recordStatusList;

                }

                //判断是否为公司订单

                if(this.isSubDistributor){

                    //检查一下使用权限

                    let check = this.permissionCheck();

                    if(this.recordList.length == 0){
                        
                        this.finished=!check;

                        if(check){

                            this.getStaffSelectList();

                        }else{

                            return;

                        }

                    }

                }

                if(this.$route.meta.scrollTop){

                    this.$refs.recordListScrollView.scrollTop=this.$route.meta.scrollTop;


                }

                //检查是否存在需要更新的数据
   

                this.recordUpdate();

        })

    },


    beforeDestroy(){

        this.$route.meta.scrollTop=0;
        
    }

}
</script>

<style lang="less">

.record-list-wrapper{

    height:100%;
    
    .record-list-cover{

        height:100%;

    }

    .multiple-toolbar-wrapper{

        position: absolute;

        z-index:66;

        bottom:12vh;

        right:30px;
        
        width: 40px;

        .multiple-toolbar-btn{

            width: 50px;

            height:50px;

            background:rgb(0, 160, 228);

            border-radius: 50%;
            
            text-align: center;

            line-height:50px;

            font-size:30px;

            color:#fff;

            opacity: .6;

            margin-bottom:15px;

            transition:opacity .3s;

            &:active{

                opacity: 1;

            }

        }

    }

    .hd{

        .menu{

           .base-color{
               .van-popup .van-cell{
                   &:nth-child(2){
                       color:#E46864;
                   }
               }
           }

           .date-interval{

               display: flex;

               padding:15px;

               align-items: center;

               .date-interval-item{

                   font-size:13px;

                   line-height:24px;

                   padding: 2px 8px 1px;

                   background:#f6f6f6;

                   color:#999;

                   &.confirm{

                    margin-left:40px;

                    padding: 2px 15px 1px;

                    background: #eee;

                    border-radius:3px;

                    border: 0;

                    &.live{

                        background: #00a0e4;

                        color:#fff;

                    }

                   }

               }

           }

        }

    }


    .bd{

        flex:1;

        height:0;

        overflow: hidden;

        overflow-y: auto;

        background: #f6f6f6;

        .van-pull-refresh{

            min-height:100%;

        }

        .record-item{

            background: #fff;

            margin-top:10px;

            padding: 10px 15px;

            overflow: hidden;

            position: relative;

            .record-item-multiple-overly{

                position: absolute;

                z-index:10;

                left:0;

                top:0;

                right:0;

                bottom:0;

            }

            &:first-child{

                margin-top:0;

            }

            .record-item-cover{
                
                display: flex;

            }


            .record-item-l{

                margin-top:2px;

            }

            .button-cover{

                button{

                    margin-left:10px;

                    &:first-child{

                        margin-left:0;

                    }

                }

            }

            &.m-selected{

                box-shadow:0 0 8px rgba(0, 160, 228,.5) inset;

            }
            
            .record-item-r{

                flex:1;

                width: 0;

                padding-left:10px;

                .info{

                    padding-bottom:6px;

                    .customer{

                        display: flex;

                        justify-content: space-between;

                        align-items: flex-end;

                    }

                    .name{

                        font-size:16px;

                    }

                    .phone,.record-time{

                        font-size:12px;

                        color:#999;

                    }

                    .record-time.close{

                        position: relative;

                        &:after{

                            content:"";

                            position: absolute;

                            width: 50px;

                            height:50px;

                            background: url('../../assets/images/close.png') scroll no-repeat center center / 100% 100%;

                            right:-15px;

                            top:-20px;

                            transform: rotate(25deg);

                            z-index:10;

                        }

                    }

                    .phone{

                        vertical-align: bottom;

                        padding-left:8px;

                    }
                    
                    .house-name{

                        font-size:14px;

                        line-height:28px;

                        padding-top:3px;

                    }

                    .visit-date{

                        font-size:14px;

                        line-height:28px;

                        padding-top:3px;

                    }

                    .label-item{

                        line-height:24px;

                        font-size:13px;

                        display: flex;
                        
                        span:nth-child(2){

                            flex: 1;

                            width: 0;

                        }

                        &.primary{
                            color:#00a0e4;
                        }

                    }

                    .staff-info{

                        line-height:24px;

                        font-size:13px;

                        display:flex;

                        align-items: center;

                        a{

                            flex:1;

                            width: 0;

                            position: relative;

                            z-index:30;

                            padding-left:5px;

                            .call-icon{

                                color:#00a0e4;

                                font-size:14px;

                                padding-left:2px;

                                position: relative;

                                top:1px;

                                transform: rotate(20deg);

                            }

                        }

                    }

                }

                .des{

                    padding-top:13px;

                    .record-type{

                        display: flex;

                        justify-content: space-between;

                        align-items: center;

                        .record-type-status{

                            font-size:14px;

                            color:#666;
                            position: relative;
                            z-index:5;
                            &_icon{
                                padding-left:6px;
                                line-height:1;
                                font-size:0;
                                color:rgb(0, 160, 228,.6);
                            }
                            &.await{

                                color:rgb(0, 160, 228,.6);

                            }

                            span{

                                &.faild{

                                    color:rgba(252, 54, 54,.6);

                                }

                                &.success{

                                    color:rgb(3, 187, 3,.6);

                                }

                                &.warning{

                                    color:#ff976a;

                                }

                            }

                        }

                        .record-copy{

                            padding: 4px 10px 3px;

                            font-size:12px;

                            color:rgb(3, 187, 3);

                            border: 0;

                            background: transparent;

                            &:after{

                                border-color:rgb(3, 187, 3);

                                border-radius:5px;

                            }

                            &:active{

                                background: rgba(0, 255, 0,.05);

                            }

                        }

                        .record-again{

                            padding: 4px 10px 3px;

                            font-size:12px;

                            color:rgb(223, 112, 39);

                            border: 0;

                            background: transparent;

                            &:after{

                                border-color:rgb(223, 112, 39);

                                border-radius:5px;

                            }

                            &:active{

                                background: rgba(255, 145, 0, 0.05);

                            }

                        }

                    }

                }

            }

            .record-extra{

                padding-top:10px;

                .recordFailed{

                    color:#999;

                    display: flex;

                    align-items: flex-start;

                    span{
                        
                        line-height:18px;

                    }

                    span:nth-child(2){

                        flex:1;

                        width: 0;

                    }

                }

            }

        }
        

    }

    

}

</style>
